"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageUrl = exports.searchUserByIdEnabledHash = exports.applyToUserMany = exports.waitMs = exports.sortByUsername = exports.escapeAsRegExpAndTrim = exports.valueToStr = exports.searchableAccountTypes = exports.worldProfileIcon = exports.profileLinkType = exports.profileIcon = exports.genSearchGroups = exports.SearchGroupsPropKeys = exports.isWorldSearchParamsPresent = exports.genSearchUsers = exports.isSearchParamsPresent = exports.isPresentTimeProps = exports.isPresentDateString = exports.isValidDateTimeString = exports.timePropsToDateString = exports.parseLocation = exports.parseUserLocation = exports.joinUserAndProfiles = exports.withGroupPartTime = exports.withWorldPartTime = exports.withPartTime = exports.userWorldIds = exports.withLocationInfo = exports.worldInstanceExpireTicks = void 0;
exports.isWorldNeedDetailFetch = isWorldNeedDetailFetch;
exports.isWorldInstanceNeedFetch = isWorldInstanceNeedFetch;
exports.joinWorldAndProfiles = joinWorldAndProfiles;
exports.generateInstanceFullId = generateInstanceFullId;
exports.withInstanceFullId = withInstanceFullId;
exports.locationInfoToString = locationInfoToString;
exports.locationInfoToLaunchUrl = locationInfoToLaunchUrl;
exports.locationInfoToTsubokuraUrl = locationInfoToTsubokuraUrl;
exports.locationInfoToVRChatComUrl = locationInfoToVRChatComUrl;
exports.locationInfoToVRChatComWorldUrl = locationInfoToVRChatComWorldUrl;
exports.dateStringToTimeProps = dateStringToTimeProps;
exports.timePropsToDisplay = timePropsToDisplay;
exports.displayDeepProp = displayDeepProp;
exports.dateToDisplay = dateToDisplay;
exports.dateFromNowToDisplay = dateFromNowToDisplay;
exports.isSearchParamsEqual = isSearchParamsEqual;
exports.parseSearchParamQuery = parseSearchParamQuery;
exports.stringifySearchParamQuery = stringifySearchParamQuery;
exports.isWorldSearchParamsEqual = isWorldSearchParamsEqual;
exports.genSearchWorlds = genSearchWorlds;
exports.pick = pick;
exports.omit = omit;
exports.toggleTag = toggleTag;
exports.isTagArrayEqual = isTagArrayEqual;
exports.isITagArrayEqual = isITagArrayEqual;
exports.isUserProfileTagArrayEqual = isUserProfileTagArrayEqual;
exports.isWorldShallowEqual = isWorldShallowEqual;
exports.isMissingWorldIdsEqual = isMissingWorldIdsEqual;
exports.isUserEqual = isUserEqual;
exports.isProfileEqual = isProfileEqual;
exports.isProfilePrivateInfoEqual = isProfilePrivateInfoEqual;
exports.isTempProfilePrivateInfoEqual = isTempProfilePrivateInfoEqual;
exports.isGroupEqual = isGroupEqual;
exports.isUserJoinnedInGroup = isUserJoinnedInGroup;
exports.isContentsSeriesEqual = isContentsSeriesEqual;
exports.toIdHash = toIdHash;
exports.toExistHash = toExistHash;
exports.rejectById = rejectById;
exports.stringifyBoolean = stringifyBoolean;
exports.decodeBoolean = decodeBoolean;
exports.isWorldLoading = isWorldLoading;
exports.isAprilFool = isAprilFool;
exports.routePageProps = routePageProps;
exports.mapUserDefinedGroupUsers = mapUserDefinedGroupUsers;
exports.uniqUserModels = uniqUserModels;
exports.eachSlice = eachSlice;
exports.replaceArray = replaceArray;
exports.hasProfilePrivateMemo = hasProfilePrivateMemo;
exports.isPrivateMemoSynced = isPrivateMemoSynced;
exports.isNotPrivateMemoSyncedAndCanAutoSync = isNotPrivateMemoSyncedAndCanAutoSync;
exports.canSyncToVRC = canSyncToVRC;
var parttime_1 = __importStar(require("parttime"));
var dayjs_1 = __importDefault(require("dayjs"));
var advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
var localizedFormat_1 = __importDefault(require("dayjs/plugin/localizedFormat"));
var relativeTime_1 = __importDefault(require("dayjs/plugin/relativeTime"));
var uuid_1 = require("uuid");
var qs_1 = __importDefault(require("qs"));
var ILocationInfo_1 = require("./models/ILocationInfo");
var Permission_1 = require("./models/Permission");
var i18n_1 = require("./i18n");
require("dayjs/locale/ja");
require("dayjs/locale/ko");
var Platform_1 = require("../enums/Platform");
dayjs_1.default.extend(advancedFormat_1.default);
dayjs_1.default.extend(localizedFormat_1.default);
dayjs_1.default.extend(relativeTime_1.default);
var worldExpireTicks = 2 * 60 * 60 * 1000;
exports.worldInstanceExpireTicks = 60 * 1000;
function isWorldNeedDetailFetch(world, now) {
    if (now === void 0) { now = new Date(); }
    return world.description == null || now.getTime() - new Date(world.dbUpdatedAt).getTime() > worldExpireTicks;
}
function isWorldInstanceNeedFetch(worldInstance, now) {
    if (now === void 0) { now = new Date(); }
    return (!worldInstance ||
        !worldInstance.fetchedAt ||
        now.getTime() - worldInstance.fetchedAt.getTime() > exports.worldInstanceExpireTicks);
}
var withLocationInfo = function (users) {
    return users.map(function (user) { return (__assign(__assign({}, user), { locationInfo: (0, exports.parseUserLocation)(user) })); });
};
exports.withLocationInfo = withLocationInfo;
var userWorldIds = function (users) {
    return users.map(function (user) { return user.locationInfo.worldId; }).filter(function (id) { return id; });
};
exports.userWorldIds = userWorldIds;
var withPartTime = function (userProfiles) {
    return userProfiles.map(function (userProfile) { return (__assign(__assign({}, userProfile), { joinedAtPartTime: dateStringToTimeProps(userProfile.joinedAt), birthdayPartTime: dateStringToTimeProps(userProfile.birthday) })); });
};
exports.withPartTime = withPartTime;
var withWorldPartTime = function (worldModel) { return (__assign(__assign({}, worldModel), { publicationDatePartTime: dateStringToTimeProps((0, exports.isValidDateTimeString)(worldModel.publicationDate) ? worldModel.publicationDate : ""), labsPublicationDatePartTime: dateStringToTimeProps(worldModel.labsPublicationDate), createdAtPartTime: dateStringToTimeProps(worldModel.createdAt), updatedAtPartTime: dateStringToTimeProps(worldModel.updatedAt) })); };
exports.withWorldPartTime = withWorldPartTime;
var withGroupPartTime = function (groups) {
    return groups.map(function (group) { return (__assign(__assign({}, group), { groupCreatedAtPartTime: dateStringToTimeProps(group.groupCreatedAt) })); });
};
exports.withGroupPartTime = withGroupPartTime;
var joinUserAndProfiles = function (users, profiles) {
    var profilesHash = {};
    for (var _i = 0, profiles_1 = profiles; _i < profiles_1.length; _i++) {
        var profile = profiles_1[_i];
        profilesHash[profile.id] = profile;
    }
    var userModels = [];
    for (var _a = 0, users_1 = users; _a < users_1.length; _a++) {
        var user = users_1[_a];
        var profile = profilesHash[user.id];
        userModels.push(__assign(__assign({}, user), { profile: profile }));
    }
    return userModels;
};
exports.joinUserAndProfiles = joinUserAndProfiles;
function joinWorldAndProfiles(worlds, profiles) {
    var worldModels = {};
    var profilesHash = toIdHash(profiles);
    for (var i = 0; i < worlds.length; ++i) {
        var world = worlds[i];
        var profile = profilesHash[world.id];
        worldModels[world.id] = (0, exports.withWorldPartTime)(__assign(__assign({}, world), { profile: profile }));
    }
    return worldModels;
}
var worldPermissionStrHash = {
    hidden: "friends-plus",
    friends: "friends",
    private: "invite",
    public: "public",
};
var worldPermissionGroupStrHash = {
    public: "group-public",
    plus: "group-plus",
    members: "group",
};
var worldPermissionStrHashInvert = {
    "friends-plus": "hidden",
    friends: "friends",
    "invite-plus": "private",
    public: undefined,
};
var parseUserLocation = function (_a) {
    var location = _a.location, travelingToLocation = _a.travelingToLocation;
    if (location === "traveling")
        return __assign(__assign({}, (0, exports.parseLocation)(travelingToLocation)), { traveling: true });
    return (0, exports.parseLocation)(location);
};
exports.parseUserLocation = parseUserLocation;
var parseLocation = function (link) {
    if (!link)
        return { permission: "none" };
    if (link === "offline")
        return { permission: "offline" };
    if (link === "private")
        return { permission: "private" };
    var result = /^([^:]+):([^~]+)(?:~(hidden|friends|private|public|group)(?:\(([^)]+)\))?)?.*?(~canRequestInvite)?(?:~groupAccessType\((public|plus|members)\))?.*?(~region\([^)]+\))?/.exec(link);
    if (!result)
        return { permission: "error" };
    var permission = result[3] === "group"
        ? worldPermissionGroupStrHash[result[6]]
        : result[3]
            ? worldPermissionStrHash[result[3]]
            : "public";
    return {
        worldId: result[1],
        instanceId: result[2],
        permission: permission === "invite" && result[5] ? "invite-plus" : permission,
        owner: result[4],
        instanceFullId: link.replace(/^[^:]+:/, ""),
        region: ILocationInfo_1.strToRegion[result[7] || ""],
    };
};
exports.parseLocation = parseLocation;
function generateInstanceFullId(info, nonce) {
    if (!nonce && info.permission !== "public") {
        nonce = (0, uuid_1.v4)();
    }
    var regionStr = ILocationInfo_1.regionToStr[info.region] || "";
    switch (info.permission) {
        case "public":
            return "".concat(info.instanceId).concat(regionStr);
        case "friends-plus":
            return "".concat(info.instanceId, "~hidden(").concat(info.owner, ")").concat(regionStr, "~nonce(").concat(nonce, ")");
        case "friends":
            return "".concat(info.instanceId, "~friends(").concat(info.owner, ")").concat(regionStr, "~nonce(").concat(nonce, ")");
        case "invite-plus":
            return "".concat(info.instanceId, "~private(").concat(info.owner, ")~canRequestInvite").concat(regionStr, "~nonce(").concat(nonce, ")");
        case "invite":
            return "".concat(info.instanceId, "~private(").concat(info.owner, ")").concat(regionStr, "~nonce(").concat(nonce, ")");
        case "group-public":
            return "".concat(info.instanceId, "~group(").concat(info.owner, ")~groupAccessType(public)").concat(regionStr);
        case "group-plus":
            return "".concat(info.instanceId, "~group(").concat(info.owner, ")~groupAccessType(plus)").concat(regionStr);
        case "group":
            return "".concat(info.instanceId, "~group(").concat(info.owner, ")~groupAccessType(members)").concat(regionStr);
        default:
            return undefined;
    }
}
function withInstanceFullId(info, nonce) {
    if ((0, ILocationInfo_1.isJoinableLocationInfo)(info)) {
        return __assign(__assign({}, info), { instanceFullId: generateInstanceFullId(info, nonce) });
    }
    return info;
}
function locationInfoToString(info) {
    if (info.permission === "error" || info.permission === "none")
        return undefined;
    if (info.permission === "offline" || info.permission === "private")
        return info.permission;
    return "".concat(info.worldId, ":").concat(info.instanceFullId);
}
function locationInfoToLaunchUrl(info) {
    if (!ILocationInfo_1.isJoinablePermission[info.permission])
        return;
    return "vrchat://launch?id=".concat(locationInfoToString(info));
}
function locationInfoToTsubokuraUrl(info) {
    if (!ILocationInfo_1.isJoinablePermission[info.permission])
        return;
    var url = new URL("http://teruaki-tsubokura.com/vrchat");
    url.searchParams.set("world_id", info.worldId || "");
    url.searchParams.set("instanceId", info.instanceId || "");
    url.searchParams.set("permission", info.permission);
    url.searchParams.set("owner", info.owner || "");
    return url;
}
function locationInfoToVRChatComUrl(info) {
    if (!ILocationInfo_1.isJoinablePermission[info.permission])
        return;
    var url = new URL("https://vrchat.com/home/launch");
    url.searchParams.set("worldId", info.worldId || "");
    url.searchParams.set("instanceId", info.instanceFullId || "");
    return url;
}
function locationInfoToVRChatComWorldUrl(info) {
    if (!ILocationInfo_1.isJoinablePermission[info.permission])
        return;
    var url = new URL("https://vrchat.com/home/world/".concat(info.worldId));
    return url;
}
var timePropsToDateString = function (timeProps) {
    return "".concat("0000".concat(timeProps.year || "").slice(-4), "-").concat("00".concat(timeProps.month || "").slice(-2), "-").concat("00".concat(timeProps.date || "").slice(-2));
};
exports.timePropsToDateString = timePropsToDateString;
function dateStringToTimeProps(dateString) {
    if (!dateString)
        return {};
    var year = dateString.slice(0, 4);
    var month = dateString.slice(5, 7);
    var date = dateString.slice(8, 10);
    var timeProps = {};
    if (year !== "0000")
        timeProps.year = Number(year);
    if (month !== "00")
        timeProps.month = Number(month);
    if (date !== "00")
        timeProps.date = Number(date);
    return timeProps;
}
var isValidDateTimeString = function (dateTimeString) {
    return !!dateTimeString && dateTimeString !== "1970-01-01T00:00:00.000Z";
};
exports.isValidDateTimeString = isValidDateTimeString;
var isPresentDateString = function (dateString) {
    return Boolean(dateString && dateString !== "0000-00-00");
};
exports.isPresentDateString = isPresentDateString;
var isPresentTimeProps = function (timeProps) {
    return Boolean(timeProps && Object.keys(timeProps).length > 0);
};
exports.isPresentTimeProps = isPresentTimeProps;
function timePropsToDisplay(timeProps) {
    if (!timeProps)
        return "";
    if (timeProps.year) {
        if (timeProps.month) {
            if (timeProps.date) {
                return (0, dayjs_1.default)(new Date(timeProps.year, timeProps.month - 1, timeProps.date))
                    .locale((0, i18n_1.lang)())
                    .format("LL");
            }
            return (0, dayjs_1.default)(new Date(timeProps.year, timeProps.month - 1, 1))
                .locale((0, i18n_1.lang)())
                .format("YYYY MMM");
        }
        return timeProps.year.toString();
    }
    if (timeProps.month) {
        if (timeProps.date) {
            return (0, dayjs_1.default)(new Date(1970, timeProps.month - 1, timeProps.date))
                .locale((0, i18n_1.lang)())
                .format("MMMM Do");
        }
        return (0, dayjs_1.default)(new Date(1970, timeProps.month - 1, 1))
            .locale((0, i18n_1.lang)())
            .format("MMMM");
    }
    if (timeProps.date) {
        return (0, dayjs_1.default)(new Date(1970, 0, timeProps.date)).locale((0, i18n_1.lang)()).format("Do");
    }
    return "";
}
function displayDeepProp(prop, key) {
    return prop == null ? "" : prop[key] || "";
}
function dateToDisplay(date) {
    return (0, dayjs_1.default)(date).locale((0, i18n_1.lang)()).format("LL");
}
function dateFromNowToDisplay(date) {
    return (0, dayjs_1.default)(date).locale((0, i18n_1.lang)()).fromNow();
}
var isSearchParamsPresentGenericKeys = ["username", "profile", "privateMemo", "world", "haveProfile"];
var isSearchParamsPresentTimePropsKeys = [
    "joinedAtStart",
    "joinedAtEnd",
    "birthdayStart",
    "birthdayEnd",
    "friendAtStart",
    "friendAtEnd",
    "lastLoginStart",
    "lastLoginEnd",
];
var isSearchParamsPresent = function (searchParams, ignorePermission) {
    if (ignorePermission === void 0) { ignorePermission = false; }
    if (isSearchParamsPresentGenericKeys.some(function (key) { return !!searchParams[key]; }))
        return true;
    if (!ignorePermission &&
        searchParams.permission &&
        Object.keys(searchParams.permission).some(function (_permission) { return !!searchParams.permission[_permission]; }))
        return true;
    if (searchParams.ignorePlatform &&
        Object.keys(searchParams.ignorePlatform).some(function (platform) { return !!searchParams.ignorePlatform[platform]; }))
        return true;
    if (searchParams.tags && searchParams.tags.length)
        return true;
    if (searchParams.advancedSearch) {
        if (searchParams.accountName)
            return true;
        if (searchParams.havePrivateMemo != null)
            return true;
        if (isSearchParamsPresentTimePropsKeys.some(function (key) { return (0, exports.isPresentTimeProps)(searchParams[key]); }))
            return true;
    }
    return false;
};
exports.isSearchParamsPresent = isSearchParamsPresent;
function isSearchParamsEqual(searchParams1, searchParams2) {
    if (isSearchParamsPresentGenericKeys.some(function (key) { return (0, exports.valueToStr)(searchParams1[key]) !== (0, exports.valueToStr)(searchParams2[key]); }))
        return false;
    var permission1 = searchParams1.permission || {};
    var permission2 = searchParams2.permission || {};
    for (var _i = 0, permissions_1 = Permission_1.permissions; _i < permissions_1.length; _i++) {
        var _permission = permissions_1[_i];
        if (Boolean(permission1[_permission]) !== Boolean(permission2[_permission]))
            return false;
    }
    var ignorePlatform1 = searchParams1.ignorePlatform || {};
    var ignorePlatform2 = searchParams2.ignorePlatform || {};
    for (var _a = 0, platforms_1 = Platform_1.platforms; _a < platforms_1.length; _a++) {
        var platform_1 = platforms_1[_a];
        if (Boolean(ignorePlatform1[platform_1]) !== Boolean(ignorePlatform2[platform_1]))
            return false;
    }
    if (!isTagArrayEqual(searchParams1.tags, searchParams2.tags))
        return false;
    if (Boolean(searchParams1.haveProfile) !== Boolean(searchParams2.haveProfile))
        return false;
    if (Boolean(searchParams1.advancedSearch) !== Boolean(searchParams2.advancedSearch))
        return false;
    if (searchParams1.accountName !== searchParams2.accountName)
        return false;
    if (searchParams1.accountType !== searchParams2.accountType)
        return false;
    if (searchParams1.havePrivateMemo !== searchParams2.havePrivateMemo)
        return false;
    if (isSearchParamsPresentTimePropsKeys.some(function (key) { return !(0, parttime_1.equals)(searchParams1[key] || {}, searchParams2[key] || {}); }))
        return false;
    return true;
}
var genSearchUsers = function (_a) {
    var searchParams = _a.searchParams, worlds = _a.worlds, getUserFirstUnmuteAt = _a.getUserFirstUnmuteAt, allPrivateMemoSynced = _a.allPrivateMemoSynced;
    return function (users) {
        if (searchParams.username) {
            var re_1 = (0, exports.escapeAsRegExpAndTrim)(searchParams.username);
            users = users.filter(function (user) { var _a; return ((_a = user.username) === null || _a === void 0 ? void 0 : _a.match(re_1)) || user.displayName.match(re_1); });
        }
        if (searchParams.permission) {
            var _loop_1 = function (permission) {
                if (searchParams.permission[permission]) {
                    // true=非表示
                    users = users.filter(function (user) { return user.locationInfo.permission !== permission; });
                }
            };
            for (var _i = 0, permissions_2 = Permission_1.permissions; _i < permissions_2.length; _i++) {
                var permission = permissions_2[_i];
                _loop_1(permission);
            }
        }
        if (searchParams.profile) {
            var re_2 = (0, exports.escapeAsRegExpAndTrim)(searchParams.profile);
            users = users.filter(function (user) { return user.profile && user.profile.profile && user.profile.profile.match(re_2); });
        }
        if (searchParams.tags && searchParams.tags.length) {
            var targetLength_1 = searchParams.tags.length;
            var targetTags_1 = {};
            for (var _a = 0, _b = searchParams.tags; _a < _b.length; _a++) {
                var tag = _b[_a];
                targetTags_1[tag] = true;
            }
            // AND
            users = users.filter(function (user) {
                return user.profile &&
                    user.profile.tags &&
                    user.profile.tags.filter(function (tag) { return targetTags_1[tag.name]; }).length === targetLength_1;
            });
        }
        if (searchParams.privateMemo) {
            var re_3 = (0, exports.escapeAsRegExpAndTrim)(searchParams.privateMemo);
            users = users.filter(function (user) {
                return (user.note && user.note.match(re_3)) ||
                    (user.profile && user.profile.privateMemo && user.profile.privateMemo.match(re_3));
            });
        }
        if (searchParams.world) {
            var re_4 = (0, exports.escapeAsRegExpAndTrim)(searchParams.world);
            users = users.filter(function (user) {
                var world = worlds[user.locationInfo.worldId];
                return world && world.name.match(re_4);
            });
        }
        if (searchParams.ignorePlatform) {
            var _loop_2 = function (platform_2) {
                if (searchParams.ignorePlatform[platform_2]) {
                    // true=非表示
                    users = users.filter(function (user) { return user.last_platform && user.last_platform !== platform_2; });
                }
            };
            for (var _c = 0, platforms_2 = Platform_1.platforms; _c < platforms_2.length; _c++) {
                var platform_2 = platforms_2[_c];
                _loop_2(platform_2);
            }
        }
        if (searchParams.haveProfile) {
            users = users.filter(function (user) { return user.profile && user.profile.profile; });
        }
        if (searchParams.haveUnsyncPrivateMemo && !allPrivateMemoSynced) {
            users = users.filter(function (user) { return !isPrivateMemoSynced(user); });
        }
        if (searchParams.advancedSearch) {
            if (searchParams.accountName) {
                var re_5 = (0, exports.escapeAsRegExpAndTrim)(searchParams.accountName);
                var accountType_1 = searchParams.accountType || "twitter";
                if (accountType_1 === "steamProfileId") {
                    users = users.filter(function (user) {
                        return user.profile &&
                            ((user.profile.steamProfileId && user.profile.steamProfileId.match(re_5)) ||
                                (user.profile.steamCustomUrlId && user.profile.steamCustomUrlId.match(re_5)));
                    });
                }
                else {
                    users = users.filter(function (user) { return user.profile && user.profile[accountType_1] && user.profile[accountType_1].match(re_5); });
                }
            }
            if (searchParams.havePrivateMemo != null) {
                if (searchParams.havePrivateMemo) {
                    users = users.filter(function (user) { return user.note || (user.profile && user.profile.privateMemo); });
                }
                else {
                    users = users.filter(function (user) { return !user.note && (!user.profile || !user.profile.privateMemo); });
                }
            }
            if ((0, exports.isPresentTimeProps)(searchParams.joinedAtStart)) {
                users = users.filter(function (user) {
                    return user.profile &&
                        (0, exports.isPresentTimeProps)(user.profile.joinedAtPartTime) &&
                        (0, parttime_1.compare)(user.profile.joinedAtPartTime, searchParams.joinedAtStart) >= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(searchParams.joinedAtEnd)) {
                users = users.filter(function (user) {
                    return user.profile &&
                        (0, exports.isPresentTimeProps)(user.profile.joinedAtPartTime) &&
                        (0, parttime_1.compare)(user.profile.joinedAtPartTime, searchParams.joinedAtEnd) <= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(searchParams.birthdayStart)) {
                users = users.filter(function (user) {
                    return user.profile &&
                        (0, exports.isPresentTimeProps)(user.profile.birthdayPartTime) &&
                        (0, parttime_1.compare)(user.profile.birthdayPartTime, searchParams.birthdayStart) >= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(searchParams.birthdayEnd)) {
                users = users.filter(function (user) {
                    return user.profile &&
                        (0, exports.isPresentTimeProps)(user.profile.birthdayPartTime) &&
                        (0, parttime_1.compare)(user.profile.birthdayPartTime, searchParams.birthdayEnd) <= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(searchParams.friendAtStart)) {
                users = users.filter(function (user) {
                    var friendAt = getUserFirstUnmuteAt(user.id);
                    return friendAt && (0, parttime_1.compare)(friendAt, searchParams.friendAtStart) >= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(searchParams.friendAtEnd)) {
                users = users.filter(function (user) {
                    var friendAt = getUserFirstUnmuteAt(user.id);
                    return friendAt && (0, parttime_1.compare)(friendAt, searchParams.friendAtEnd) <= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(searchParams.lastLoginStart)) {
                users = users.filter(function (user) {
                    var at = user.last_login ? new Date(user.last_login) : undefined;
                    var validAt = at && !Number.isNaN(at.getTime());
                    if (!validAt && user.locationInfo.permission !== "offline")
                        return true;
                    if (!validAt)
                        return false;
                    return (0, parttime_1.compare)(at, searchParams.lastLoginStart) >= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(searchParams.lastLoginEnd)) {
                users = users.filter(function (user) {
                    var at = user.last_login ? new Date(user.last_login) : undefined;
                    var validAt = at && !Number.isNaN(at.getTime());
                    if (!validAt && user.locationInfo.permission !== "offline")
                        return false;
                    if (!validAt)
                        return true;
                    return (0, parttime_1.compare)(at, searchParams.lastLoginEnd) <= 0;
                });
            }
        }
        return users;
    };
};
exports.genSearchUsers = genSearchUsers;
var lastLoginEnabledHash = "b1b6472a611f03756ed7b69f23704e4c";
function parseSearchParamQuery(searchString) {
    var parsed = qs_1.default.parse(searchString, { ignoreQueryPrefix: true });
    var tags = typeof parsed.tags === "string" ? [parsed.tags] : parsed.tags;
    var permission = (typeof parsed.permission === "string" ? [parsed.permission] : parsed.permission || []).reduce(function (all, key) {
        var _a;
        return (__assign(__assign({}, all), (_a = {}, _a[key] = true, _a)));
    }, {});
    var ignorePlatform = (typeof parsed.ignorePlatform === "string"
        ? [parsed.ignorePlatform]
        : parsed.ignorePlatform || []).reduce(function (all, key) {
        var _a;
        return (__assign(__assign({}, all), (_a = {}, _a[key] = true, _a)));
    }, {});
    var timeProps = isSearchParamsPresentTimePropsKeys.reduce(function (all, key) {
        var _a;
        return (__assign(__assign({}, all), (_a = {}, _a[key] = parsed[key] ? parttime_1.default.parse(parsed[key]) : undefined, _a)));
    }, {});
    return __assign(__assign(__assign({}, parsed), { tags: tags, permission: permission, haveProfile: !!parsed.haveProfile || undefined, havePrivateMemo: { true: true, false: false }[parsed.havePrivateMemo], haveUnsyncPrivateMemo: parsed.haveUnsyncPrivateMemo === "true", ignorePlatform: ignorePlatform, advancedSearch: !!parsed.advancedSearch, lastLoginEnabled: parsed.lastLoginEnabled === lastLoginEnabledHash }), timeProps);
}
function stringifySearchParamQuery(searchParam) {
    var formatted = __assign(__assign(__assign(__assign({}, searchParam), { permission: searchParam.permission ? Permission_1.permissions.filter(function (key) { return searchParam.permission[key]; }) : undefined, haveProfile: searchParam.haveProfile || undefined, haveUnsyncPrivateMemo: searchParam.haveUnsyncPrivateMemo ? "true" : undefined, ignorePlatform: searchParam.ignorePlatform
            ? Platform_1.platforms.filter(function (key) { return searchParam.ignorePlatform[key]; })
            : undefined, advancedSearch: searchParam.advancedSearch || undefined }), isSearchParamsPresentTimePropsKeys.reduce(function (all, key) {
        var _a;
        var dateString = new parttime_1.default(searchParam[key]).toDateString();
        return __assign(__assign({}, all), (_a = {}, _a[key] = dateString === "*-*-*" ? undefined : dateString, _a));
    }, {})), { lastLoginEnabled: searchParam.lastLoginEnabled ? lastLoginEnabledHash : undefined });
    return qs_1.default.stringify(formatted, { arrayFormat: "repeat" });
}
var isWorldSearchParamsPresentGenericKeys = ["name", "description", "authorName", "privateMemo"];
var isWorldSearchParamsPresentTimePropsKeys = [
    "publicationDateStart",
    "publicationDateEnd",
    "labsPublicationDateStart",
    "labsPublicationDateEnd",
    "createdAtStart",
    "createdAtEnd",
    "updatedAtStart",
    "updatedAtEnd",
];
var isWorldSearchParamsPresent = function (searchParams) {
    if (isWorldSearchParamsPresentGenericKeys.some(function (key) { return !!searchParams[key]; }))
        return true;
    if (searchParams.tags && searchParams.tags.length)
        return true;
    if (searchParams.privateTags && searchParams.privateTags.length)
        return true;
    if (searchParams.ignorePlatform &&
        Object.keys(searchParams.ignorePlatform).some(function (platform) { return !!searchParams.ignorePlatform[platform]; }))
        return true;
    if (searchParams.ignorePublicStatus &&
        Object.keys(searchParams.ignorePublicStatus).some(function (_status) { return !!searchParams.ignorePublicStatus[_status]; }))
        return true;
    if (searchParams.tags && searchParams.tags.length)
        return true;
    if (searchParams.advancedSearch) {
        if (searchParams.capacityMax != null)
            return true;
        if (searchParams.capacityMin != null)
            return true;
        if (isWorldSearchParamsPresentTimePropsKeys.some(function (key) { return (0, exports.isPresentTimeProps)(searchParams[key]); }))
            return true;
    }
    return false;
};
exports.isWorldSearchParamsPresent = isWorldSearchParamsPresent;
function isWorldSearchParamsEqual(searchParams1, searchParams2) {
    if (isWorldSearchParamsPresentGenericKeys.some(function (key) { return (0, exports.valueToStr)(searchParams1[key]) !== (0, exports.valueToStr)(searchParams2[key]); }))
        return false;
    var ignorePlatform1 = searchParams1.ignorePlatform || {};
    var ignorePlatform2 = searchParams2.ignorePlatform || {};
    for (var _i = 0, platforms_3 = Platform_1.platforms; _i < platforms_3.length; _i++) {
        var platform_3 = platforms_3[_i];
        if (Boolean(ignorePlatform1[platform_3]) !== Boolean(ignorePlatform2[platform_3]))
            return false;
    }
    var ignorePublicStatus1 = searchParams1.ignorePublicStatus || {};
    var ignorePublicStatus2 = searchParams2.ignorePublicStatus || {};
    for (var _a = 0, _b = ["public", "communityLabs", "private"]; _a < _b.length; _a++) {
        var publicStatus = _b[_a];
        if (Boolean(ignorePublicStatus1[publicStatus]) !== Boolean(ignorePublicStatus2[publicStatus]))
            return false;
    }
    if (!isTagArrayEqual(searchParams1.tags, searchParams2.tags))
        return false;
    if (!isTagArrayEqual(searchParams1.privateTags, searchParams2.privateTags))
        return false;
    if (searchParams1.advancedSearch !== searchParams2.advancedSearch)
        return false;
    if (searchParams1.capacityMin !== searchParams2.capacityMin)
        return false;
    if (searchParams1.capacityMax !== searchParams2.capacityMax)
        return false;
    if (isWorldSearchParamsPresentTimePropsKeys.some(function (key) { return !(0, parttime_1.equals)(searchParams1[key] || {}, searchParams2[key] || {}); }))
        return false;
    return true;
}
function genSearchWorlds(_a) {
    var worldSearchParams = _a.worldSearchParams, worlds = _a.worlds;
    return function searchWorlds(ids) {
        if (worldSearchParams.name) {
            var re_6 = (0, exports.escapeAsRegExpAndTrim)(worldSearchParams.name);
            ids = ids.filter(function (id) { return worlds[id].name.match(re_6); });
        }
        if (worldSearchParams.description) {
            var re_7 = (0, exports.escapeAsRegExpAndTrim)(worldSearchParams.description);
            ids = ids.filter(function (id) { return worlds[id].description && worlds[id].description.match(re_7); });
        }
        // if (worldSearchParams.tags) {}
        if (worldSearchParams.authorName) {
            var re_8 = (0, exports.escapeAsRegExpAndTrim)(worldSearchParams.authorName);
            ids = ids.filter(function (id) { return worlds[id].authorName && re_8.test(worlds[id].authorName); });
        }
        // if (worldSearchParams.privateMemo) {}
        // if (worldSearchParams.privateTags) {}
        if (worldSearchParams.ignorePlatform) {
            if (worldSearchParams.ignorePlatform.standalonewindows) {
                ids = ids.filter(function (id) { return !worlds[id].unityPackages.some(function (up) { return up.platform === Platform_1.Platform.standalonewindows; }); });
            }
            if (worldSearchParams.ignorePlatform.android) {
                ids = ids.filter(function (id) { return !worlds[id].unityPackages.some(function (up) { return up.platform === Platform_1.Platform.android; }); });
            }
        }
        if (worldSearchParams.ignorePublicStatus) {
            if (worldSearchParams.ignorePublicStatus.public) {
                ids = ids.filter(function (id) { return !(worlds[id].releaseStatus === "public" && !worlds[id].tags.includes("system_labs")); });
            }
            if (worldSearchParams.ignorePublicStatus.communityLabs) {
                ids = ids.filter(function (id) { return !(worlds[id].releaseStatus === "public" && worlds[id].tags.includes("system_labs")); });
            }
            if (worldSearchParams.ignorePublicStatus.private) {
                ids = ids.filter(function (id) { return !(worlds[id].releaseStatus !== "public"); });
            }
        }
        if (worldSearchParams.advancedSearch) {
            if (worldSearchParams.capacityMin) {
                ids = ids.filter(function (id) { return worlds[id].capacity >= worldSearchParams.capacityMin; });
            }
            if (worldSearchParams.capacityMax) {
                ids = ids.filter(function (id) { return worlds[id].capacity <= worldSearchParams.capacityMax; });
            }
            if ((0, exports.isPresentTimeProps)(worldSearchParams.publicationDateStart)) {
                ids = ids.filter(function (id) {
                    return (0, exports.isPresentTimeProps)(worlds[id].publicationDatePartTime) &&
                        (0, parttime_1.compare)(worlds[id].publicationDatePartTime, worldSearchParams.publicationDateStart) >= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(worldSearchParams.publicationDateEnd)) {
                ids = ids.filter(function (id) {
                    return (0, exports.isPresentTimeProps)(worlds[id].publicationDatePartTime) &&
                        (0, parttime_1.compare)(worlds[id].publicationDatePartTime, worldSearchParams.publicationDateEnd) <= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(worldSearchParams.labsPublicationDateStart)) {
                ids = ids.filter(function (id) {
                    return (0, exports.isPresentTimeProps)(worlds[id].labsPublicationDatePartTime) &&
                        (0, parttime_1.compare)(worlds[id].labsPublicationDatePartTime, worldSearchParams.labsPublicationDateStart) >=
                            0;
                });
            }
            if ((0, exports.isPresentTimeProps)(worldSearchParams.labsPublicationDateEnd)) {
                ids = ids.filter(function (id) {
                    return (0, exports.isPresentTimeProps)(worlds[id].labsPublicationDatePartTime) &&
                        (0, parttime_1.compare)(worlds[id].labsPublicationDatePartTime, worldSearchParams.labsPublicationDateEnd) <= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(worldSearchParams.createdAtStart)) {
                ids = ids.filter(function (id) {
                    return (0, exports.isPresentTimeProps)(worlds[id].createdAtPartTime) &&
                        (0, parttime_1.compare)(worlds[id].createdAtPartTime, worldSearchParams.createdAtStart) >= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(worldSearchParams.createdAtEnd)) {
                ids = ids.filter(function (id) {
                    return (0, exports.isPresentTimeProps)(worlds[id].createdAtPartTime) &&
                        (0, parttime_1.compare)(worlds[id].createdAtPartTime, worldSearchParams.createdAtEnd) <= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(worldSearchParams.updatedAtStart)) {
                ids = ids.filter(function (id) {
                    return (0, exports.isPresentTimeProps)(worlds[id].updatedAtPartTime) &&
                        (0, parttime_1.compare)(worlds[id].updatedAtPartTime, worldSearchParams.updatedAtStart) >= 0;
                });
            }
            if ((0, exports.isPresentTimeProps)(worldSearchParams.updatedAtEnd)) {
                ids = ids.filter(function (id) {
                    return (0, exports.isPresentTimeProps)(worlds[id].updatedAtPartTime) &&
                        (0, parttime_1.compare)(worlds[id].updatedAtPartTime, worldSearchParams.updatedAtEnd) <= 0;
                });
            }
        }
        return ids;
    };
}
exports.SearchGroupsPropKeys = ["searchGroupName"];
var genSearchGroups = function (state) { return function (groups) {
    if (state.searchGroupName) {
        var re_9 = (0, exports.escapeAsRegExpAndTrim)(state.searchGroupName);
        groups = groups.filter(function (user) { return user.name && user.name.match(re_9); });
    }
    return groups;
}; };
exports.genSearchGroups = genSearchGroups;
exports.profileIcon = {
    profile: { icon: "user", color: "black" },
    site: { icon: "home", color: "purple" },
    twitter: { icon: "twitter", color: "blue" },
    steamProfileId: { icon: "steam", color: "grey" },
    steamCustomUrlId: { icon: "steam", color: "grey" },
    discord: { icon: "discord", color: "violet" },
    booth: { icon: "shop", color: "red" },
    vroidhub: { icon: "child", color: "grey" },
    github: { icon: "github", color: "black" },
    gitlab: { icon: "gitlab", color: "orange" },
    youtube: { icon: "youtube", color: "red" },
    niconico: { icon: "tv", color: "grey" },
    joinedAt: { icon: "calendar", color: "black" },
    birthday: { icon: "birthday", color: "black" },
    tags: { icon: "tag", color: "blue" },
    privateMemo: { icon: "bars", color: "black" },
    privateMemoCreatedAt: { icon: "calendar", color: "black" },
    privateMemoUpdatedAt: { icon: "calendar", color: "black" },
};
var profileLinkTypes = [
    { name: "Twitter", icon: { name: "twitter", color: "blue" }, test: /^https?:\/\/(?:twitter|x)\.com/ },
    { name: "Steam", icon: { name: "steam", color: "grey" }, test: /^https?:\/\/steamcommunity\.com/ },
    { name: "Discord", icon: { name: "discord", color: "violet" }, test: /^https?:\/\/discord\.gg/ },
    { name: "Booth", icon: { name: "shop", color: "red" }, test: /^https?:\/\/(?:[^./]+\.)?booth\.pm/ },
    { name: "VRoid Hub", icon: { name: "child", color: "grey" }, test: /^https?:\/\/hub\.vroid\.com/ },
    { name: "GitHub", icon: { name: "github", color: "black" }, test: /^https?:\/\/github\.com/ },
    { name: "Gitlab", icon: { name: "gitlab", color: "orange" }, test: /^https?:\/\/gitlab\.com/ },
    {
        name: "YouTube",
        icon: { name: "youtube", color: "red" },
        test: /^https?:\/\/(?:(?:[^./]+\.)?youtube\.com|youtu\.be)/,
    },
    {
        name: "niconico",
        icon: { name: "tv", color: "grey" },
        test: /^https?:\/\/(?:(?:[^./]+\.)?nicovideo\.jp|nico\.ms)/,
    },
    {
        name: "Link",
        icon: { name: "linkify", color: "grey" },
        test: /.*/,
    },
];
var profileLinkType = function (link) {
    for (var i = 0; i < profileLinkTypes.length; ++i) {
        if (profileLinkTypes[i].test.test(link))
            return profileLinkTypes[i];
    }
    throw new Error("!");
};
exports.profileLinkType = profileLinkType;
exports.worldProfileIcon = {
    authorName: { icon: "user", color: "black" },
    description: { icon: "comment", color: "black" },
    profile: { icon: "comment alternate outline", color: "black" },
    site: { icon: "home", color: "purple" },
    twitter: { icon: "twitter", color: "blue" },
    discord: { icon: "discord", color: "violet" },
    booth: { icon: "shop", color: "red" },
    github: { icon: "github", color: "black" },
    gitlab: { icon: "gitlab", color: "orange" },
    createdAt: { icon: "plus square", color: "black" },
    updatedAt: { icon: "refresh", color: "black" },
    tags: { icon: "tag", color: "blue" },
    privateMemo: { icon: "bars", color: "black" },
    privateTags: { icon: "folder", color: "black" },
    capacity: { icon: "users", color: "black" },
    favorites: { icon: "favorite", color: "black" },
    publicationDate: { icon: "bullhorn", color: "black" },
    labsPublicationDate: { icon: "lab", color: "black" },
    visits: { icon: "eye", color: "black" },
    heat: { icon: "thermometer empty", color: "black" },
    unityPackages: { icon: "computer", color: "black" },
};
exports.searchableAccountTypes = [
    "twitter",
    "steamProfileId",
    "discord",
    "github",
    "gitlab",
];
/**
 * キー数に対して時間が指数的増加を示すので{...obj}より{...pick(obj, keys)}のほうが基本速い
 * @param obj obj
 * @param keys keys
 */
function pick(obj, keys) {
    // 参考: https://github.com/jonschlinkert/object.pick
    var res = {};
    var count = keys.length;
    var index = -1;
    while (++index < count) {
        var key = keys[index];
        res[key] = obj[key];
    }
    return res;
}
function omit(obj, keys) {
    var res = {};
    var objKeys = Object.keys(obj);
    var keysExists = toExistHash(keys);
    var count = objKeys.length;
    var index = -1;
    while (++index < count) {
        var key = objKeys[index];
        if (!keysExists[key])
            res[key] = obj[key];
    }
    return res;
}
var valueToStr = function (value) { return (value == null ? "" : value.toString()); };
exports.valueToStr = valueToStr;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var escapeAsRegExpAndTrim = function (str) { return new RegExp(str.trim().replace(reRegExpChar, "\\$&"), "i"); };
exports.escapeAsRegExpAndTrim = escapeAsRegExpAndTrim;
function toggleTag(tags, tag) {
    var i = tags.indexOf(tag);
    if (i === -1)
        return __spreadArray(__spreadArray([], tags, true), [tag], false);
    var newTags = tags.slice();
    newTags.splice(i, 1);
    return newTags;
}
var sortByUsername = function (users) {
    return users
        .slice()
        .sort(function (a, b) {
        return (a.username || a.displayName) < (b.username || b.displayName)
            ? -1
            : (a.username || a.displayName) > (b.username || b.displayName)
                ? 1
                : 0;
    });
};
exports.sortByUsername = sortByUsername;
function isTagArrayEqual(src, dst) {
    if (src === void 0) { src = []; }
    if (dst === void 0) { dst = []; }
    if (src.length !== dst.length)
        return false;
    var tagHash = {};
    for (var i = 0; i < src.length; ++i)
        tagHash[src[i]] = false;
    for (var i = 0; i < dst.length; ++i)
        tagHash[dst[i]] = false;
    if (Object.keys(tagHash).length !== src.length)
        return false;
    return true;
}
function isITagArrayEqual(src, dst) {
    if (src.length !== dst.length)
        return false;
    var tagHash = {};
    for (var i = 0; i < src.length; ++i)
        tagHash[src[i].name + src[i].count] = false;
    for (var i = 0; i < dst.length; ++i)
        tagHash[dst[i].name + dst[i].count] = false;
    if (Object.keys(tagHash).length !== src.length)
        return false;
    return true;
}
function isUserProfileTagArrayEqual(src, dst) {
    if (src.length !== dst.length)
        return false;
    var tagHash = {};
    for (var i = 0; i < src.length; ++i)
        tagHash[src[i].name + src[i].locked] = false;
    for (var i = 0; i < dst.length; ++i)
        tagHash[dst[i].name + dst[i].locked] = false;
    if (Object.keys(tagHash).length !== src.length)
        return false;
    return true;
}
function mergeKeys(src, dst) {
    // 少ないキー数だと比較的に遅いが15を越えるあたりからObject.keys(Object.assign({}, src, dst))を越える
    var srcKeys = Object.keys(src);
    var dstKeys = Object.keys(dst);
    var keysHash = {};
    for (var i = 0; i < srcKeys.length; ++i)
        keysHash[srcKeys[i]] = true;
    for (var i = 0; i < dstKeys.length; ++i)
        keysHash[dstKeys[i]] = true;
    return Object.keys(keysHash);
}
function isWorldShallowEqual(srcWorld, dstWorld) {
    return srcWorld === dstWorld;
}
function isMissingWorldIdsEqual(ids1, ids2) {
    if (ids1.length !== ids2.length)
        return false;
    return ids1[0] === ids2[0]; // ユニークなキューとして使うので先頭さえ合っていれば正しい
}
function isUserEqual(srcUser, dstUser) {
    if (!isProfileEqual(srcUser.profile, dstUser.profile))
        return false;
    for (var _i = 0, _a = mergeKeys(srcUser, dstUser); _i < _a.length; _i++) {
        var key = _a[_i];
        if (key === "profile")
            continue;
        if (key === "locationInfo")
            continue;
        if (srcUser[key] !== dstUser[key])
            return false;
    }
    return true;
}
function isProfileEqual(srcProfile, dstProfile, ignoreTags) {
    if (ignoreTags === void 0) { ignoreTags = false; }
    if (srcProfile == null || dstProfile == null)
        return srcProfile == null && dstProfile == null;
    for (var _i = 0, _a = mergeKeys(srcProfile, dstProfile); _i < _a.length; _i++) {
        var key = _a[_i];
        if (key === "privateMemo" || key === "privateTags")
            continue;
        if (key === "joinedAtPartTime" || key === "birthdayPartTime")
            continue;
        if (key === "tags") {
            if (ignoreTags || isUserProfileTagArrayEqual(srcProfile.tags || [], dstProfile.tags || [])) {
                continue;
            }
            else {
                return false;
            }
        }
        if ((0, exports.valueToStr)(srcProfile[key]) !== (0, exports.valueToStr)(dstProfile[key]))
            return false;
    }
    if (!isProfilePrivateInfoEqual(srcProfile, dstProfile))
        return false;
    return true;
}
function isProfilePrivateInfoEqual(srcProfile, dstProfile) {
    if (srcProfile == null || dstProfile == null)
        return srcProfile == null && dstProfile == null;
    if (srcProfile.privateMemo !== dstProfile.privateMemo)
        return false;
    if (srcProfile.privateMemoIsSynced !== dstProfile.privateMemoIsSynced)
        return false;
    if (!isTagArrayEqual(srcProfile.privateTags, dstProfile.privateTags))
        return false;
    return true;
}
function isTempProfilePrivateInfoEqual(srcProfile, dstProfile) {
    if (srcProfile.tempPrivateMemo !== dstProfile.tempPrivateMemo)
        return false;
    if (!isTagArrayEqual(srcProfile.tempPrivateTags, dstProfile.tempPrivateTags))
        return false;
    return true;
}
function isGroupEqual(srcGroup, dstGroup) {
    if (srcGroup == null || dstGroup == null)
        return srcGroup == null && dstGroup == null;
    for (var _i = 0, _a = mergeKeys(srcGroup, dstGroup); _i < _a.length; _i++) {
        var key = _a[_i];
        if (key === "groupCreatedAtPartTime")
            continue;
        if (key === "thumbnailImageFile") {
            if (srcGroup[key] !== dstGroup[key])
                return false;
            continue;
        }
        if ((0, exports.valueToStr)(srcGroup[key]) !== (0, exports.valueToStr)(dstGroup[key]))
            return false;
    }
    return true;
}
function isUserJoinnedInGroup(group, user) {
    if (!group || !user || !user.profile || !user.profile.tags || !user.profile.tags.length)
        return false;
    var tags = user.profile.tags;
    for (var i = 0; i < tags.length; ++i) {
        if (tags[i].name === group.tagName)
            return true;
    }
    return false;
}
function isContentsSeriesEqual(src, dst) {
    if (src == null || dst == null)
        return src == null && dst == null;
    var keys = mergeKeys(src, dst);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (src[key] !== dst[key])
            return false;
    }
    return true;
}
function toIdHash(items) {
    var hash = {};
    for (var i = 0; i < items.length; ++i) {
        var item = items[i];
        hash[item.id] = item;
    }
    return hash;
}
function toExistHash(values) {
    var hash = {};
    for (var i = 0; i < values.length; ++i)
        hash[values[i]] = true;
    return hash;
}
function rejectById(oldItems, newItems) {
    var existIds = {};
    for (var i = 0; i < oldItems.length; ++i)
        existIds[oldItems[i].id] = true;
    return newItems.filter(function (item) { return !existIds[item.id]; });
}
function stringifyBoolean(flag) {
    return "".concat(flag);
}
var decodeBooleanHash = {
    true: true,
    false: false,
    undefined: undefined,
};
function decodeBoolean(flag) {
    return flag ? decodeBooleanHash[flag] : flag;
}
function isWorldLoading(worldId, _a) {
    var needWorldIds = _a.needWorldIds, missingWorldIds = _a.missingWorldIds;
    return needWorldIds.some(function (ids) { return ids.indexOf(worldId) !== -1; }) || missingWorldIds.indexOf(worldId) !== -1;
}
var aprilFoolYear = 2019;
var aprilFool = [new Date(aprilFoolYear, 4 - 1, 1), new Date(aprilFoolYear, 4 - 1, 2)];
function isAprilFool(now) {
    if (now === void 0) { now = new Date(); }
    return aprilFool[0] <= now && now < aprilFool[1];
}
function routePageProps(_a, defaults) {
    var location = _a.location, history = _a.history;
    var search = new URLSearchParams(location.search.slice(1));
    var _b = defaults || {}, page = _b.page, setPage = _b.setPage, pageSize = _b.pageSize, setPageSize = _b.setPageSize;
    var currentPage = search.get("page");
    var currentPageSize = search.get("pageSize");
    if ((!currentPage && page) || (!currentPageSize && pageSize)) {
        if (!currentPage && page)
            search.set("page", page.toString());
        if (!currentPageSize && pageSize)
            search.set("pageSize", pageSize.toString());
        history.replace(__assign(__assign({}, location), { search: "?".concat(search.toString()) }));
    }
    return {
        page: Number(currentPage || page),
        pageSize: Number(currentPageSize || pageSize),
        setPage: function (newPage) {
            search.set("page", "".concat(newPage));
            if (setPage)
                setPage(newPage);
            history.push(__assign(__assign({}, location), { search: "?".concat(search.toString()) }));
        },
        setPageSize: function (newPageSize) {
            search.set("pageSize", "".concat(newPageSize));
            if (setPageSize)
                setPageSize(newPageSize);
            history.push(__assign(__assign({}, location), { search: "?".concat(search.toString()) }));
        },
    };
}
function mapUserDefinedGroupUsers(usersDefinedGroups, userModels) {
    return usersDefinedGroups.map(function (userDefinedGroup) {
        var targetUserModels = userModels.filter(function (_a) {
            var id = _a.id;
            return userDefinedGroup.users[id];
        });
        var primaryUserModels = targetUserModels.filter(function (userModel) { return userDefinedGroup.users[userModel.id].primary; });
        return {
            id: userDefinedGroup.id,
            name: userDefinedGroup.name,
            users: targetUserModels,
            hasPrimary: !!primaryUserModels.filter(function (userModel) { return (0, Permission_1.isOnline)(userModel.locationInfo.permission); }).length,
            hasPrimaryJoinable: !!primaryUserModels.filter(function (userModel) { return (0, Permission_1.isJoinable)(userModel.locationInfo.permission); })
                .length,
        };
    });
}
function uniqUserModels(userModels) {
    var ids = {};
    return userModels.filter(function (_a) {
        var id = _a.id;
        if (ids[id])
            return false;
        return (ids[id] = true);
    });
}
var waitMs = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
exports.waitMs = waitMs;
function eachSlice(arr, n) {
    var dup = __spreadArray([], arr, true);
    var result = [];
    var length = dup.length;
    while (length > 0) {
        result.push(dup.splice(0, n));
        length = dup.length;
    }
    return result;
}
function replaceArray(source, index, item) {
    var newSource = source.slice();
    newSource.splice(index, 1, item);
    return newSource;
}
function hasProfilePrivateMemo(userModel) {
    var _a;
    return !!((_a = userModel === null || userModel === void 0 ? void 0 : userModel.profile) === null || _a === void 0 ? void 0 : _a.privateMemo);
}
function isPrivateMemoSynced(userModel) {
    var _a;
    return Boolean(!((_a = userModel === null || userModel === void 0 ? void 0 : userModel.profile) === null || _a === void 0 ? void 0 : _a.privateMemo) || userModel.profile.privateMemoIsSynced);
}
function isNotPrivateMemoSyncedAndCanAutoSync(userModel) {
    var _a;
    return (((_a = userModel === null || userModel === void 0 ? void 0 : userModel.profile) === null || _a === void 0 ? void 0 : _a.privateMemo) &&
        !userModel.profile.privateMemoIsSynced &&
        canSyncToVRC(userModel.profile.privateMemo) &&
        (!userModel.note || userModel.profile.privateMemo === userModel.note));
}
function canSyncToVRC(memo) {
    return memo && memo.length <= 256; // VRCがサロゲートペアを考慮していないのでそれにあわせる
}
var applyToUserMany = function (state) {
    var onlineFriends = state.onlineFriends, offlineFriends = state.offlineFriends, favoriteFriends = state.favoriteFriends, searchUsersById = state.searchUsersById;
    var onlineIndexes = {};
    for (var i = 0; i < onlineFriends.length; ++i) {
        onlineIndexes[onlineFriends[i].id] = i;
    }
    var offlineIndexes = {};
    for (var i = 0; i < offlineFriends.length; ++i) {
        offlineIndexes[offlineFriends[i].id] = i;
    }
    var favoriteIndexes = [];
    for (var j = 0; j < favoriteFriends.length; ++j) {
        favoriteIndexes[j] = {};
        for (var i = 0; i < favoriteFriends[j].length; ++i) {
            favoriteIndexes[j][favoriteFriends[j][i].id] = i;
        }
    }
    var searchUsersByIdIndexes = {};
    if (searchUsersById) {
        for (var i = 0; i < searchUsersById.length; ++i) {
            searchUsersByIdIndexes[searchUsersById[i].id] = i;
        }
    }
    var data = {
        onlineFriends: onlineFriends,
        offlineFriends: offlineFriends,
        favoriteFriends: favoriteFriends,
        searchUsersById: searchUsersById,
    };
    return {
        get: function () { return data; },
        getById: function (targetUserId) {
            var index;
            index = onlineIndexes[targetUserId];
            if (index != null) {
                return data.onlineFriends[index];
            }
            index = offlineIndexes[targetUserId];
            if (index != null) {
                return data.offlineFriends[index];
            }
            for (var j = 0; j < data.favoriteFriends.length; ++j) {
                index = favoriteIndexes[j][targetUserId];
                if (index != null) {
                    return data.favoriteFriends[j][index];
                }
            }
            index = searchUsersByIdIndexes[targetUserId];
            if (index != null && searchUsersById) {
                return searchUsersById[index];
            }
            return undefined;
        },
        replaceById: function (targetUserId, genItem) {
            var index;
            index = onlineIndexes[targetUserId];
            if (index != null) {
                data.onlineFriends = replaceArray(data.onlineFriends, index, genItem(data.onlineFriends[index]));
            }
            index = offlineIndexes[targetUserId];
            if (index != null) {
                data.offlineFriends = replaceArray(data.offlineFriends, index, genItem(data.offlineFriends[index]));
            }
            for (var j = 0; j < data.favoriteFriends.length; ++j) {
                index = favoriteIndexes[j][targetUserId];
                if (index != null) {
                    data.favoriteFriends = replaceArray(data.favoriteFriends, j, replaceArray(data.favoriteFriends[j], index, genItem(data.favoriteFriends[j][index])));
                }
            }
            index = searchUsersByIdIndexes[targetUserId];
            if (index != null && data.searchUsersById) {
                data.searchUsersById = replaceArray(data.searchUsersById, index, genItem(data.searchUsersById[index]));
            }
        },
        apply: function (currentState) {
            if (currentState.onlineFriends !== data.onlineFriends) {
                currentState.setOnlineFriends(data.onlineFriends);
            }
            if (currentState.offlineFriends !== data.offlineFriends) {
                currentState.setOfflineFriends(data.offlineFriends);
            }
            if (currentState.favoriteFriends !== data.favoriteFriends) {
                currentState.setFavoriteFriends(data.favoriteFriends);
            }
            if (currentState.searchUsersById !== data.searchUsersById &&
                currentState.setSearchUsersById &&
                data.searchUsersById) {
                currentState.setSearchUsersById(data.searchUsersById);
            }
        },
    };
};
exports.applyToUserMany = applyToUserMany;
exports.searchUserByIdEnabledHash = "47a827f9343261f2dca4d41f642aea1c";
var imageUrlRe = /^https:\/\/[a-z0-9.-]*\bvrchat\b[a-z0-9.-]+\/api\/1\/(image|file)\/(.*)$/;
var imageUrl = function (url) {
    return url == null ? url : url.replace(imageUrlRe, "".concat(origin, "/api/vrcapi/$1/$2"));
};
exports.imageUrl = imageUrl;
